import {Modal} from '../../../../../components/modal-legacy/Modal'
import {Button} from 'src/components/button/Button.tsx'
import {useTranslation} from 'react-i18next'
import {Flexbox} from 'src/components/flexbox/Flexbox.tsx'
import {ModalParagraph} from 'src/components/modal-atoms/ModalAtoms.tsx'
import {Spinner} from 'src/components/spinner/Spinner.tsx'
import {FC, useState} from 'react'
import {useAdminChangeFreelancerStatus} from 'src/features/admin/services/useAdminChangeFreelancerStatus.ts'
import {TextArea} from 'src/components/textarea/Textarea.tsx'
import {Freelancer, FreelancerStatus} from 'src/features/admin/types.ts'
import {StyledFooter, StyledTitle, StyledModalBody} from './style'
import {MAX_REASON_CHARACTERS} from '../freelancer-actions-dropdown/FreelancerActionsDropdown'
import {useDispatch} from 'react-redux'
import {showAlert} from 'src/store/appGenerics'
import {ALERT_LEVELS} from 'src/helpers/constants'

interface SuspendFreelancerModalProps {
    freelancer: Freelancer
    onClose: () => void
}

export const SuspendFreelancerModal: FC<SuspendFreelancerModalProps> = ({freelancer, onClose}) => {
    const {t} = useTranslation()
    const [reason, setReason] = useState(freelancer?.suspension_reason ?? '')
    const dispatch = useDispatch()
    const changeFreelancerStatusMutation = useAdminChangeFreelancerStatus(freelancer.id, {
        onSuccess: () => {
            dispatch(
                showAlert({
                    message: t('impersonate_statuses:status_changed_success'),
                    level: ALERT_LEVELS.SUCCESS
                })
            )
            onClose()
        }
    })

    return (
        <Modal onClose={onClose} width="432px">
            <StyledModalBody>
                <Flexbox direction="column" gap={2}>
                    <StyledTitle>
                        {t('admin:freelancers_deactivation:suspend_modal:title', {freelancerName: freelancer.name})}
                    </StyledTitle>
                    <ModalParagraph>{t('admin:freelancers_deactivation:suspend_modal:description')}</ModalParagraph>
                </Flexbox>

                <TextArea
                    label={t('admin:freelancers_deactivation:more_details_label')}
                    placeholder={t('admin:freelancers_deactivation:more_details_placeholder')}
                    rows={4}
                    value={reason}
                    onChange={e => setReason(e.target.value)}
                    maxLength={MAX_REASON_CHARACTERS}
                    helpText={t('commons:x_characters_available', {
                        count: MAX_REASON_CHARACTERS - (reason?.length ?? 0)
                    })}
                />

                <StyledFooter>
                    <Button
                        variant="tertiary"
                        shape="text"
                        onClick={onClose}
                        disabled={changeFreelancerStatusMutation.isLoading}
                    >
                        {t('commons:cancel')}
                    </Button>

                    <Button
                        variant="primary"
                        onClick={() =>
                            changeFreelancerStatusMutation.mutate({
                                status: FreelancerStatus.Enum.suspended,
                                suspension_reason: reason
                            })
                        }
                        disabled={changeFreelancerStatusMutation.isLoading || !reason}
                    >
                        {t('admin:freelancers_deactivation:suspend')}
                        {changeFreelancerStatusMutation.isLoading && <Spinner />}
                    </Button>
                </StyledFooter>
            </StyledModalBody>
        </Modal>
    )
}

SuspendFreelancerModal.displayName = 'SuspendFreelancerModal'
